/* =============================================================================
   beUNIQ — "Buy Now" on the product page

   Replaces Shopify's wallet button with one that can carry our own label.
   Shop Pay's button has to read "Buy with Shop"; that is its branding and no
   theme setting changes it, so a button saying Buy Now must be ours.

   The button itself is a plain submit inside the product form, so the add
   runs through the theme's normal path with whatever variant and quantity
   are selected. This only watches for that add to finish and then sends the
   shopper on to checkout — it never posts to /cart/add itself, which would
   either double-add the item or race the theme's own request.

   Armed only by a click on our button. Add to cart, and quick-add from a
   recommendations carousel, raise the same event, and someone adding a
   second rug has not asked to leave for the checkout.

   Without JavaScript the button still submits and still adds to the cart.
   The shopper lands in the cart rather than the checkout, which is a far
   smaller failure than a button that does nothing.
   ========================================================================== */

class BeuniqBuyNow extends HTMLElement {
  connectedCallback() {
    this.form = document.getElementById(this.dataset.formId)
    this.trigger = this.querySelector('[data-buy-now]')
    if (!this.form || !this.trigger) return

    this.armed = false

    this.onClick = () => {
      this.armed = true
      // If the add fails the event never arrives and this would stay armed,
      // sending a later unrelated add to checkout. Disarm on a timer.
      clearTimeout(this.timer)
      this.timer = setTimeout(() => {
        this.armed = false
      }, 10000)
    }

    this.onAdded = (event) => {
      if (!this.armed) return

      // Belt and braces: the add must also have come from this form.
      const origin = event.target
      const fromThisForm =
        origin === this.form ||
        (origin instanceof Node && (this.form.contains(origin) || origin.contains(this.form)))
      if (!fromThisForm) return

      this.armed = false
      clearTimeout(this.timer)

      const root = window.Shopify?.routes?.root || '/'
      window.location.href = `${root}checkout`
    }

    this.trigger.addEventListener('click', this.onClick)
    document.addEventListener('ajaxProduct:added', this.onAdded)
  }

  disconnectedCallback() {
    clearTimeout(this.timer)
    if (this.trigger && this.onClick) this.trigger.removeEventListener('click', this.onClick)
    if (this.onAdded) document.removeEventListener('ajaxProduct:added', this.onAdded)
  }
}

if (!customElements.get('beuniq-buy-now')) {
  customElements.define('beuniq-buy-now', BeuniqBuyNow)
}
